/**
 * Single Source of Truth: Verified Engineering Metrics & Impact Data
 */

export const metricsData = [
    {
        id: 'experience',
        value: '4+ Years',
        numericValue: 4,
        label: 'Lead & Architect Roles',
        sub: 'Grihseva, Phnk, AMRITPEX',
        description: 'Demonstrated technical leadership across startups, national initiatives, and enterprise systems.',
    },
    {
        id: 'endpoints',
        value: '260+',
        numericValue: 260,
        label: 'Production REST APIs',
        sub: 'Built with Node.js, Express & AWS',
        description: 'High-throughput endpoints engineered with robust security, rate limiting, and comprehensive test coverage.',
    },
    {
        id: 'latency',
        value: '<50ms',
        numericValue: 50,
        label: 'Real-Time Latency',
        sub: 'WebSockets & Redis Streams',
        description: 'Measured sub-50ms message propagation across distributed clustered microservices and event brokers.',
    },
    {
        id: 'reliability',
        value: '99.98%',
        numericValue: 99.98,
        label: 'Production Reliability',
        sub: 'Enterprise SLA & Zero Downtime',
        description: 'Demonstrated 99.98% availability across high-concurrency cloud systems and physical GovTech deployments.',
    },
];

export const heroQuickStats = [
    { label: 'Latency SLA', value: '<50ms' },
    { label: 'Production APIs', value: '260+' },
    { label: 'Scale Capacity', value: '100k+ Concurrency' },
    { label: 'Uptime Reliability', value: '99.98%' },
];

export default metricsData;
